// extracted by mini-css-extract-plugin
export default {"update_btn":"styles_update_btn__LrYRu","cancel_btn":"styles_cancel_btn__k1veQ","container":"styles_container__LC3x8","text":"styles_text__GvPk-"};